
import CandidateInterview from './CandidateInterview';

export default CandidateInterview;